import { render } from "./Minus.vue?vue&type=template&id=88bbcd12&scoped=true"
import script from "./Minus.vue?vue&type=script&lang=js"
export * from "./Minus.vue?vue&type=script&lang=js"

import "./Minus.vue?vue&type=style&index=0&id=88bbcd12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88bbcd12"]])

export default __exports__